import { memo, useCallback, useMemo, useState } from "react";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import useStore from "store";
import Text from "components/Text";

import messages from "store/messages";

import CarTypes from "./CarTypes";
import FuelType from "./FuelType";
import GearboxType from "./GearboxType";
import MobileFilters from "./MobileFilters";
import PriceRange from "./PriceRange";

function Filters() {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const { palette, other } = useTheme();
  const { filters, setFilters } = useStore();
  const filtersCount = useMemo(() => Object.values(filters).filter((item:string[]) => item.length).length, [filters]);

  const handleMobileClick = useCallback(() => {
    document.body.classList.add("modal-open");
    setIsModalOpened(true);
  }, []);

  const MobileBody = useMemo(() => styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    @media (min-width: 1024px) {
      display: none;
    }
  `, []);

  const MobileText = useMemo(() => styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    border-radius: ${other.borderRadius};
    padding: 7px 17px;
    height: 36px;
    border: 1px solid ${palette.primary.dark};
    &.active{
      border: 1px solid ${palette.additional.dark};
      background-color: ${palette.additional.light};
    }
  `, [other.borderRadius, palette.additional.dark, palette.additional.light, palette.primary.dark]);

  const Body = useMemo(() => styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    @media (max-width: 1024px) {
      display: none;
    }
  `, []);

  const onClear = useCallback(() => {
    setFilters({ carTypesFilter: [], fuelTypesFilter: [], gearboxFilter: [], priceRangeFilter: [] });
  }, [setFilters]);

  return (
    <>
      <MobileBody>
        <MobileText className={`${filtersCount > 0 ? "active" : ""}`}>
          <Text
            tag="span"
            variant={filtersCount > 0 ? "normalSmallAdditional" : "normalSmall"}
            onClick={handleMobileClick}
          >
            <FormattedMessage {...messages.filtersCount} values={{ count: filtersCount }} />
          </Text>
          {filtersCount > 0 && (
            <Text tag="span" id="close-icon" variant="normalAdditional" onClick={onClear}>
              <i className="las la-times-circle" />
            </Text>
          )}
        </MobileText>
        {isModalOpened && <MobileFilters setOpened={setIsModalOpened} />}
      </MobileBody>
      <Body>
        <CarTypes />
        <PriceRange />
        <FuelType />
        <GearboxType />
      </Body>
    </>
  );
}
export default memo(Filters);
